export const isSupportedGuidelineMethodology = (methodology = "") => {
  const normalized = methodology.toLowerCase();
  return (
    methodology.includes("인터뷰") ||
    methodology.includes("사용성") ||
    methodology.includes("유저빌리티") ||
    methodology.includes("컨텍스추얼") ||
    methodology.includes("맥락적 조사") ||
    normalized.includes("interview") ||
    normalized.includes("usability") ||
    normalized.includes("contextual inquiry")
  );
};

export const getSupportedGuidelineMethodologies = (methodologies = []) =>
  methodologies.filter(isSupportedGuidelineMethodology);
